import { Typography, Box } from "@mui/material";
import FooterLink from "./footerLink";
import { useMemo } from "react";

const useLawLinks = () =>
  useMemo(
    () => [
      {
        title: "Impressum",
        href: "https://www.wbstraining.de/unternehmen/impressum/",
      },
      {
        title: "AGB",
        href: "https://www.wbstraining.de/allgemeine-geschaeftsbedingungen/",
      },
      {
        title: "Datenschutz",
        href: "https://www.wbstraining.de/datenschutz/",
      },
    ],
    [],
  );

const LegalLinkList = ({
  links,
}: {
  links: { title: string; href: string }[];
}) => (
  <Box sx={{ listStyle: "none" }}>
    {links.map((link) => (
      <FooterLink
        key={link.href}
        target="_blank"
        rel="noopener"
        href={link.href}
      >
        <Typography variant="body1" component="li" sx={{ mb: 1 }}>
          {link.title}
        </Typography>
      </FooterLink>
    ))}
  </Box>
);

const LegalInformation = () => {
  const links = useLawLinks();
  return (
    <div data-testid="legalinfo">
      <Typography
        variant="h5"
        component="h5"
        sx={{ mb: 4, fontWeight: "bold" }}
        color="secondary"
      >
        Rechtliches
      </Typography>
      <LegalLinkList links={links} />
    </div>
  );
};

export default LegalInformation;
